import { render, staticRenderFns } from "./WebProfileAcceptForm.vue?vue&type=template&id=60402afd&"
import script from "./WebProfileAcceptForm.vue?vue&type=script&lang=js&"
export * from "./WebProfileAcceptForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports